module.exports = __webpack_public_path__ + "img/dfod.b5626eb2.svg";